import { Injectable } from '@angular/core';
import { Constants } from 'src/app/app.constants';
import { HttpRequestType, RequestService } from 'src/app/core/request.service';
import { BaseService } from 'src/app/shared/base/base.service';
import { ExceptionLogType } from './exception-logs.models';

@Injectable({
  providedIn: 'root'
})
export class ExceptionLogsService extends BaseService {
  constructor(public requestService: RequestService) {
    super(requestService);
}

public changeStatus(id: string | number, type: ExceptionLogType, onSuccess: Function) {
    this.requestService.createRequest(HttpRequestType.Patch, `${ Constants.contextPath }/exception-logs/${id}/${ExceptionLogType[type]}`, null, null, (response: any) => {
        onSuccess(response);
    });
}
}
